import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { IOption } from '../../../../ui/interfaces/option';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IServiceItemColumnName, ServiceItemColumnName } from '../../service-items/service-item-column-name';
import { BodyType, IServiceItem, ServiceItem, ServiceItemStatus } from '../../../../model/service-item.model';
import { BaseService } from '../../base/base.service';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { AccountRessTypeService } from '../../acc-ress-type/account-ress-type.service';
import { ServiceItemService } from '../../service-items/service-item.service';
import { ServiceItemComposeService } from '../service-item-compose.service';
import { FormService } from '../../../../shared/services/form.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { SUFFIX_ICON_FORM, WIDTH_MEDIUM_POPUP_CLASS } from '../../../../shared/constant/css-style/css-class.constant';
import { HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { IAccountRessType } from '../../../../model/acc_ress_type.model';
import {
  CompositeCreateServiceItemDTO,
  IServiceItemCompose,
  ServiceItemFilsDTO,
  ServiceItemFilsListDTO, ServiceItemFilsUpdateDTO
} from '../../../../model/service-item-compose.model';

/**
 * Permet de gérer l'ajout des service items
 */
@Component({
  selector: 'app-service-item-compose-update',
  templateUrl: './service-item-compose-update.component.html',
  animations: [fadeIn]
})
export class ServiceItemComposeUpdateComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  accountRessTypes: IOption[] = [];
  isSaving = false;
  successSave = false;
  serverHasError = false;

  theDialogRef: MatDialogRef<ServiceItemComposeUpdateComponent>;

  private subs$ = new Subject<void>();
  serviceItem: IOption[] = [];
  editForm: UntypedFormGroup;
  column: IServiceItemColumnName;

  serviceItemFils: ServiceItemFilsListDTO;

  filteredOptions: Observable<IServiceItem[]>;
  serviceItemList: ServiceItemStatus[];

  constructor(
    public baseService: BaseService,
    private accountService: AccountService,
    protected accountRessTypeService: AccountRessTypeService,
    private dialogRef: MatDialogRef<ServiceItemComposeUpdateComponent>,
    private serviceItemService: ServiceItemService,
    private serviceItemComposeService: ServiceItemComposeService,
    private formService: FormService,
    private columnName: ServiceItemColumnName,
    private fb: UntypedFormBuilder,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct service item compose add');
    const column = this.columnName.getColumnName();
    this.theDialogRef = this.dialogRef;
    this.column = column;
    this.initForm();
  }

  ngOnInit(): void {
    console.log('## init service item compose update');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {

        this.serviceItemComposeService.getServiceItemFilsSelectObs()
          .pipe(takeUntil(this.subs$)).subscribe((d: ServiceItemFilsListDTO) => {
          console.log('## service item fils selected: ', d);
          this.serviceItemFils = d;

          // on récupère les services parents
          this.serviceItemService.queryStatus().subscribe(res => {
            console.log('## Success get service item list: ', res);
            this.serviceItemList = (res.body) ? res.body : [];
            this.filteredOptions = this.editForm.get('serviceItemFilsId').valueChanges
              .pipe(
                startWith(''),
                map(value => this._filter(value))
              );

            setTimeout(res => {
              this.initValueForm(d);
            }, 100);

            console.log('## size: ' + this.serviceItemList.length);
          });
        });

        // on récupère les services parents
        /*this.serviceItemService.queryStatus().subscribe(res => {
          console.log('## Success get service item list: ', res);
          this.serviceItemList = (res.body) ? res.body : [];
          this.filteredOptions = this.editForm.get('serviceItemParentId').valueChanges
            .pipe(
              startWith(''),
              map(value => this._filter(value))
            );
          console.log('## size: ' + this.serviceItemList.length);
        });*/

        super.setLoaded();
      })
  }

  ngOnDestroy() {
    console.log('## destroy service item compose update');
    this.formService.free(this.subs$);
    this.successSave = false;
  }

  initValueForm(d: ServiceItemFilsListDTO) {
    let serviceCompose: IServiceItem;
    for(const s of this.serviceItemList) {
      if(s.id === d.serviceId) {
        serviceCompose = s;
        break;
      }
    }

    try {
      this.editForm.patchValue({
        ['compositeServiceItemId']: d.compositeServiceItemId,
        ['serviceItemFilsId']: serviceCompose,
        ['step']: d.step
      })
    }catch (e) {
      console.log('## error get country selected: ' + e.message);
    }
  }

  /**
   * initialise les champs_formulaires.
   */
  initForm() {
    try {
      this.editForm = this.fb.group({
        ['compositeServiceItemId']: ['', [Validators.required]],
        ['serviceItemFilsId']: ['', [Validators.required]],
        ['step']: ['', [Validators.required]]
      });
    }catch (e) {
      console.log('## error form: ' + e.message);
    }
  }

  private _filter(value: string): IServiceItem[] {
    let filteredList;
    try {
      console.log('## value: ', value);
      const filterValue = value.toLowerCase();
      filteredList = this.serviceItemList.filter(option => option.name.toLowerCase()
        .includes(filterValue));
    } catch (e) {
      console.log('## error filter service item: ' + e.message);
    }
    return filteredList;
  }

  getWidthPopupClass() {
    return WIDTH_MEDIUM_POPUP_CLASS;
  }

  getSuffixIconForm(): string {
    return SUFFIX_ICON_FORM;
  }

  getAllAccRessType() {
    setTimeout(() => {
      this.accountRessTypeService
        .query()
        .pipe(
          filter((mayBeOk: HttpResponse<IAccountRessType[]>) => mayBeOk.ok),
          map((response: HttpResponse<IAccountRessType[]>) => response.body)
        )
        .subscribe((res: IAccountRessType[]) => {
          let acc = (res) ? res : [];
          if(res){
            acc=res;
            this.accountRessTypes=[];
            acc.forEach(a => {
              this.accountRessTypes.push({
                ...new Option(),
                label: (a.type) ? a.type : '',
                value: (a.id) ? a.id.toString() : undefined
              })
            })
          }else{
            acc=[];
            this.accountRessTypes=[];
            this.accountRessTypes.push({
              ...new Option(),
              label: 'No account ressource type',
              value: ''
            })

          }


          /*  this.accountRessTypes.push({
             ...new Option(),
             label: 'No account ressource type',
             value: ''
           })
           console.log('## success get acc ress type list by add afterrrrr',  this.accountRessTypes);
           acc.forEach(a => {
             this.accountRessTypes.push({
               ...new Option(),
               label: (a.type) ? a.type : '',
               value: (a.id) ? a.id.toString() : undefined
             })
           }) */


        }),
        (res: HttpErrorResponse) => {
          console.log('## error get acc ress type list: ' +res.message);
        };
    }, 500)
  }

  displayFnServiceItem(subject: IServiceItem) {
    return subject ? subject.name : '';
  }

  getArrayControls(): AbstractControl[]{
    return this.serviceFilsList.controls;
  }

  get serviceFilsList() {
    return (<UntypedFormArray>this.editForm.get('serviceItemFilsList'));
  }

  addServiceFils() {
    const ipForm = this.fb.group({
      serviceItemFilsId: ['', Validators.required],
      step: ['', Validators.required]
    });
    this.serviceFilsList.push(ipForm);
  }

  /**
   * @param i the index.
   */
  removeServiceFils(i: number) {
    const s = this.serviceFilsList;
    if(s.at(i)){
      this.serviceFilsList.removeAt(i);
    }
  }

  private getForm(): ServiceItemFilsUpdateDTO {
        let i = new ServiceItemFilsUpdateDTO();
        i.serviceItemFilsId = (this.editForm.get('serviceItemFilsId').value as ServiceItemStatus).id;
        i.step = this.editForm.get('step').value;
    return i;
  }

  /**
   * Enregistre un type de account ressource.
   */
  save() {
    console.log('## save service item');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const compositeServiceItemId = this.editForm.get(['compositeServiceItemId']).value;
    let data = this.getForm();
    data.compositeServiceItemId = compositeServiceItemId;
    console.log('## data: ', data);

    this.serviceItemComposeService.updateServiceCompose(data)
      .subscribe( res => {
        this.serverHasError = false;
        this.responseFromServer();
        this.successSave = true;
        this.serviceItemComposeService.getServiceItemSelectObs()
          .pipe(takeUntil(this.subs$)).subscribe((res: IServiceItemCompose) => {
          console.log('## get service item parent selected to list fils: ', res);
          // on récupère les services fils
          let p = new HttpParams();
          p = p.set('parentId', res.serviceId);
          this.serviceItemComposeService.getAllServiceItemFils(p);
          this.closeModal();
        });


      }, error => {
        console.log('## error create service item: ', error);
        this.responseFromServer();
        this.serverHasError = true;
        this.successSave = false;
      })
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300);
  }

  private createFromForm(): IServiceItem {
    const bodyType: string =  this.editForm.get(['body_type']).value;
    const bodyContent: string = this.editForm.get(['body_content']).value;
    return {
      ...new ServiceItem(),
      id: this.editForm.get(['id']).value,
      name: this.editForm.get(['name']).value,
      description: this.editForm.get(['description']).value,
      serviceItemId: this.editForm.get(['serviceItemId']).value,
      url: (this.editForm.get(['url']).value as string).toString().trim(),
      bodyFormat: this.editForm.get(['body_format']).value,
      bodyContent: bodyContent ? bodyContent.toString().trim() : null,
      bodyType: bodyType
        ? {
          ...new BodyType(),
          field: bodyType.toString().trim()
        }
        : null,
      requestType: this.editForm.get(['request_type']).value
    };
  }

  private createFromFormWithActRessType(): IServiceItem {
    const bodyType: string =  this.editForm.get(['body_type']).value;
    const bodyContent: string = this.editForm.get(['body_content']).value;
    return {
      ...new ServiceItem(),
      id: this.editForm.get(['id']).value,
      name: this.editForm.get(['name']).value,
      description: this.editForm.get(['description']).value,
      serviceItemId: this.editForm.get(['serviceItemId']).value,
      accountRessTypeId: this.editForm.get(['accountRessTypeId']).value,
//      accountRessTypeName: this.editForm.get(['accountRessTypeName']).value,
      url: (this.editForm.get(['url']).value as string).toString().trim(),
      bodyFormat: this.editForm.get(['body_format']).value,
      bodyContent: bodyContent ? bodyContent.toString().trim() : null,
      bodyType: bodyType
        ? {
          ...new BodyType(),
          field: bodyType.toString().trim()
        }
        : null,
      requestType: this.editForm.get(['request_type']).value
    };
  }

  closeModal() {
    console.log('## close country add');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
  }
  reset(){
    this.editForm.reset();
  }

  isInvalid(): boolean {
    return this.formService.isInvalidForm(this.editForm);
  }

  isRequired(column: string): boolean {
    return this.formService.isRequired(this.editForm, column);
  }

  isInvalidDirtyOrtouched(column: string): boolean {
    return this.formService.isInvalidDirtyOrTouched(this.editForm,
      column);
  }

  getMinLength(column: string): number {
    return this.formService.getMinLength(this.editForm, column);
  }

  getMaxLength(column: string): number {
    return this.formService.getMaxLength(this.editForm, column);
  }

  hasErrorEmail(column: string): boolean {
    return this.formService.hasErrorEmail(this.editForm, column);
  }

  hasErrorPattern(column: string): boolean {
    return this.formService.hasErrorPattern(this.editForm, column);
  }

  hasErrorMinLength(column: string): boolean {
    return this.formService.hasErrorMinLength(this.editForm, column);
  }

  hasErrorMaxLength(column: string): boolean {
    return this.formService.hasErrorMaxLength(this.editForm, column);
  }

}
